export enum CustomizeBySearchTypes {
    WORKFLOW = "WORKFLOW",
    VERIFICATION_SERVICE = "VERIFICATION_SERVICE"
}
